import { Component } from '@angular/core';
import {BaseComponent} from "../../views/base.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {HelperService} from "../../lib/helper.service";
import {TranslateService} from "../../translate/translate.service";
import {EventsService} from "../../lib/EventsService";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ChartParams} from "../../views/chart/chart.component";
import * as qs from 'qs';
import {FilterParams} from "../../models/filter_form.model";
import merge from 'lodash-es/merge';
import {AlertComponent} from "../../views/modal/alert.component";
import { BillingService2 } from "../billing.service";

type TotalsResult = {
	totalRec: number,
	totalPaidRec: number,
	totalFailRec: number,
};


@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html'
})
export class ManualComponent extends BaseComponent {
	totals = {
		totalRec: 0,
		totalPaidRec: 0,
		totalFailRec: 0,
	};
	
	paidChart = new ChartParams();
	paidByProcessorChart = new ChartParams();
	paidByType = new ChartParams();
	
	stats = [];
	
	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['intBillingDateTo', 'billingDateTo', 'datePaid'],
		dateType: 'datePaid'
	};
	
	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public route: ActivatedRoute,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		this.paidByType.setOptions({
			type : 'pie'
		});
	}
	
	
	async getData() {
		const me = this;
		
		if (me.doReload.total) {
			await this.getTotal();
		}
		
		if (me.doReload.chart) {
			await this.getCharts();
		}
		
		if (me.doReload.pagination) {
			await this.getPagination();
		}
		
		if (me.doReload.stats) {
			await this.getStats();
		}
		
		this.doReload.reset();
	}
	
	
	private async getTotal() {
		const me = this;
		
		me.totalsLoader = true;
		const { totals } = await me.service2.manualPaid.total(
			me.filter.filterParams
		).toPromise();
		
		me.totals = <TotalsResult>totals;
		
		me.totalsLoader = false;
	}
	
	private async getCharts() {
		this.paidChart.showLoader();
		const { charts } = await this.service2.manualPaid.chart(
			this.filter.filterParams,
			'chart/paid',
		).toPromise();
		this.paidChart.data = charts;
		
		this.paidChart.hideLoader();
		
		this.paidByProcessorChart.showLoader();
		const { charts: charts2 } = await this.service2.manualPaid.chart(
			this.filter.filterParams,
			'chart/proccessor'
		).toPromise();
		this.paidByProcessorChart.data = charts2;
		this.paidByProcessorChart.hideLoader();
		
		this.paidByType.showLoader();
		const { charts: charts3 } = await this.service2.manualPaid.chart(
			this.filter.filterParams,
			'chart/type'
		).toPromise();
		this.paidByType.data = charts3;
		this.paidByType.hideLoader();
	}
	
	
	private async getPagination() {
		const me = this;
		
		me.paginationLoader = true;
		const pagination = await me.service2.manualPaid.pagination(
			me.filter.filterParams
		).toPromise();

		me.pagination.fill(pagination);
		me.paginationLoader = false;
	}
	
	
	private async getStats() {
		const me = this;
		
		me.statsLoader = true;
		
		const { stats } = await me.service2.manualPaid.stats(
			me.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.stats = stats;
		
		me.statsLoader = false;
	}
	
	
	onPageChange() {
		const me = this;
		
		me.doReload.onlyStats();
		
		me.filter.filterParams.page = me.pagination.page;
		
		me.filter.filterParams.dateFilterParams = me.filter.getDateFilterParams(me.filter.filterParams, this.filter.addFilterParams);
		
		let params = me.filter.getApplyFilters(me.filter.filterParams),
			url = me.router.url.split('?')[0];
		
		params = qs.stringify(params, {encode: false});
		me.router.navigateByUrl(`${url}?${params}`, {relativeTo: me.activatedRoute});
	}
	
	
	async applyFilters() {
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url    = this.router.url.split('?')[0];
		
		params = qs.stringify(params, { encode: false });
		
		this.router.navigateByUrl(`${url}?${params}`, { relativeTo: this.route });
	}
	
	
	async resetFilters() {
		this.filter.filterParams = new FilterParams();
		this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		
		let params: FilterParams = merge({}, this.filter.getDiffParams(this.filter.filterParams)),
			url = this.router.url.split('?')[0];
		
		delete params.dateFilters;
		delete params.dateFilterParams;
		
		this.router.navigate([url], { relativeTo: this.route, queryParams: params });
	}
	
	
	async downloadButton() {
		const me = this;
		
		window.location.href = me.service2.manualPaid.downloadFileRoute(
			me.filter.filterParams
		);
		
		me.modalService.open(AlertComponent, {
			title   : 'INFO',
			message : this.translate.__A('common.download file')
		});
	}
}
